import { Layout, Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faFolderOpen, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import styles from "./Sidebar.module.css";

const { Sider } = Layout;

export function Sidebar({ activeView, onViewChange }) {
  const menuItems = [
    { key: "overview", label: "Resumen General", icon: <FontAwesomeIcon icon={faChartBar} /> },
    { key: "projects", label: "Por Proyectos", icon: <FontAwesomeIcon icon={faFolderOpen} /> },
    { key: "files", label: "Gestión de Archivos", icon: <FontAwesomeIcon icon={faFileAlt} /> },
  ];

  return (
    <Sider
      width={250}
      style={{
        background: "#338BC7",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          borderRadius: 5,
          padding: "20px",
          borderBottom: "1px solid #60B5EF",
          background: "#042956",
        }}
      >
        <h1 style={{ fontSize: "18px", fontWeight: "bold", margin: 0, color: "#FFFFFF" }}>
          Informe De Actas
        </h1>
        <p style={{ fontSize: "13px", color: "#d3d3d3ff", marginTop: "4px" }}>
          Validación de Archivos
        </p>
      </div>
      <Menu
        className={styles.sidebarMenu}
        mode="inline"
        selectedKeys={[activeView]}
        onClick={(e) => onViewChange(e.key)}
        style={{
          borderRadius: 5,
          flex: 1,
          background: "#FFFFFF",
          color: "#042956",
          borderRight: 0,
          overflowX: "hidden",
        }}
        items={menuItems}
      />
    </Sider>
  );
}
